import { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThirdwebProvider } from 'thirdweb/react';
import { polygon } from 'thirdweb/chains';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import TournamentLobby from './components/TournamentLobby';
import FortniteLobby from './pages/FortniteLobby';
import CS2Lobby from './pages/CS2Lobby';
import TarkovLobby from './pages/TarkovLobby';
import OneVsOne from './pages/OneVsOne';
import Results from './components/Results';
import MyProfile from './pages/MyProfile';
import Admin from './pages/Admin';
import AdminDashboard from './pages/AdminDashboard';
import Blog from './pages/Blog';
import Leaderboard from './pages/Leaderboard';
import SeoPage, { PAGE_KEYS } from './pages/SeoPage';
import EmbedStats from './pages/EmbedStats';

// Capture ?ref=CODE from any URL and persist to localStorage so it survives
// navigation until the visitor joins the waitlist. Also re-used when they
// eventually register a user account.
function useRefCapture() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      if (ref && /^[A-Z0-9]{4,16}$/i.test(ref)) {
        localStorage.setItem('ezgame_ref', ref.toUpperCase());
      }
    } catch {}
  }, []);
}

function AppInner() {
  useRefCapture();
  const [wallet, setWallet] = useState(null);
  const location  = useLocation();
  const isAdmin   = location.pathname === '/admin' || location.pathname === '/admin/dashboard';
  const isLanding = location.pathname === '/';

  return (
    <>
      {!isAdmin && !isLanding && (
        <Navbar
          walletAddress={wallet}
          onConnect={(addr) => setWallet(addr)}
          onDisconnect={() => setWallet(null)}
        />
      )}
      <Routes>
        <Route path="/"           element={<Landing />} />
        <Route path="/lobby"      element={<TournamentLobby walletAddress={wallet} />} />
        <Route path="/fortnite"   element={<FortniteLobby walletAddress={wallet} />} />
        <Route path="/cs2"        element={<CS2Lobby      walletAddress={wallet} />} />
        <Route path="/tarkov"     element={<TarkovLobby  walletAddress={wallet} />} />
        <Route path="/1v1"        element={<OneVsOne />} />
        <Route path="/results"    element={<Results />} />
        <Route path="/profile"    element={<MyProfile walletAddress={wallet} />} />
        <Route path="/blog"       element={<Blog />} />
        <Route path="/blog/:slug" element={<Blog />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        {PAGE_KEYS.map(slug => (
          <Route key={slug} path={`/${slug}`} element={<SeoPage />} />
        ))}
        <Route path="/embed/stats/:username" element={<EmbedStats />} />
        <Route path="/admin"          element={<Admin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="*"           element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <ThirdwebProvider>
        <BrowserRouter>
          <AppInner />
          <Analytics />
        </BrowserRouter>
      </ThirdwebProvider>
    </HelmetProvider>
  );
}
